module.exports = __webpack_public_path__ + "static/IBMPlexSans-Regular-2afba28a9ce96315436db858db163c47.woff";